exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".box___2cZAD {\n  flex-grow: 1;\n  padding: 5px; }\n\n.responsive___rdRje {\n  width: 100%; }\n", "", {"version":3,"sources":["/Users/joao/Sites/workout-logger/src/components/Box/Box.sass"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa,EAAE;;AAEjB;EACE,YAAY,EAAE","file":"Box.sass","sourcesContent":[".box {\n  flex-grow: 1;\n  padding: 5px; }\n\n.responsive {\n  width: 100%; }\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"box": "box___2cZAD",
	"responsive": "responsive___rdRje"
};